export default __webpack_public_path__ + "static/media/outlook.94791ff2.png";